import React from 'react';
import { useDrop } from 'react-dnd';
import { Button } from '@mui/material';

const AddNew = ({ disabled, data = {}, returnError = () => {}, handleDrag = () => {}, onClick = () => {} }) => {
  const { name = '' } = data;
  const [{ isOver }, drop] = useDrop(() => ({
    accept: 'knight',
    canDrop: () => !disabled,
    drop: item => { if (!returnError({ name, item: item.id }) && name !== item.id) handleDrag({ name, item: item.id }); },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
    }),
  }));
  return (
    <Button
      disabled={disabled}
      ref={drop}
      style={{
        height: 39,
        width: 100,
        backgroundColor: isOver ? 'gray' : '',
        cursor: 'pointer',
        borderRadius: 50,
        border: `2px solid ${disabled ? 'gray' : '#5597B4'}`,
        color: disabled ? 'gray' : '#5597B4',
      }}
      onClick={onClick}
    >
      {disabled ? '發起人' : '新增發起人'}
    </Button>
  );
};

export default AddNew;
